/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Card 4: 90-Day Development Focus.
 *
 * Originally rendered only the static one-line question per row from the
 * content library. Steve 2026-06-11 ("90-Day Development Focus" email)
 * flagged that the dashboard version was a truncated copy of the report's
 * section 9 — and asked for the two to show the same info. So this modal
 * now prefers the AI-personalized questions (Prompt 4 output, array of
 * 1-2 questions per row), falling back to the static one-liner only when
 * AI didn't run or didn't return anything for that row.
 */
@Component({
  selector: 'app-development-focus-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './development-focus-modal.component.html',
})
export class DevelopmentFocusModalComponent {
  @Input() primaryContent: any;
  @Input() aiContent: any;

  constructor(public bsModalRef: BsModalRef) {}

  /**
   * For each focus area, prefer the AI-generated array of questions
   * (aiContent.development_focus.<area>). Fall back to the static
   * single question from the content library (primaryContent.development_focus.<area>).
   */
  get rows(): { focusArea: string; questions: string[] }[] {
    const ai = this.aiContent?.development_focus || {};
    const df = this.primaryContent?.development_focus || {};
    const pick = (key: 'sustain' | 'strengthen' | 'serve'): string[] => {
      const aiList = ai[key];
      if (Array.isArray(aiList) && aiList.length > 0) {
        return aiList.filter((q: any) => typeof q === 'string' && q.trim().length > 0);
      }
      const staticQuestion = df[key];
      return staticQuestion ? [staticQuestion] : [];
    };
    return [
      { focusArea: 'Sustain', questions: pick('sustain') },
      { focusArea: 'Strengthen', questions: pick('strengthen') },
      { focusArea: 'Serve', questions: pick('serve') },
    ].filter(r => r.questions.length > 0);
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
